/*
----- Modules ----- 
Handles column equalisation for modules system.

IMPORTANT: THIS PRE-DATES AXIS-EQUALISER.JS we were trying to use Foundation's equalizer functionality here but have since out grew it in terms of requirement, this functionality really doesn't handle nested instances of equalisation well with the addtional of not being very scalable which as a result of that will need to be refactored into using our own functionality, this is expected to be done on 825975

*/


function equaliserPrepAll(modules) {
    $(modules).each(function() {
        let context = $(this);
        equaliserPrep(context);
    });
    return true;
}

function productCollectionImageEqualiserPrep(context) {
    let container = context.parents('#productListItems, .product-carousel-module');
    container.attr('data-equalizer', 'equalise-image');
    context.attr('data-equalizer-watch', 'equalise-image');
    return container;
}


// Add require attributes for equaliser.
function equaliserPrep(context) {
    // The container of what we're going to be equalising.
    let container = context.find(expressSelectors()['modules']['grid']);
    // If we cannot find the container then fallback to context.
    if (container.length == 0) {
        container = context;
    }
    // Each item that we will be equalising.
    let item = context.find('.content-container');
    if (item.length == 0) {
        AXISDebug.output(3, "Modules: Equaliser Prep could not find content container", context);
    }
    // Assign equaliser attributes.
    container.attr('data-equalizer', "equalise-item");
    item.attr('data-equalizer-watch', 'equalise-item');

    if ((container.attr('data-equalizer') != undefined) && (item.attr('data-equalizer-watch') != undefined)) {
        return true;
    } else {
        AXISDebug.output(3,"Modals: Equaliser prep failed to assign equaliser attributes to module", context);
        return false;
    }
}

// Because we have already used foundation's equaliser on both containers (for cell height + image height ) that are guaranteed to exist we had to write a custom function for the descriptions.

function equaliseProductDescriptions(context) {
    let imageHeights = [];
    context.find('.description').each(function() {
        // Store item context.
        let item = $(this);
        // Get item height.
        let height = item.outerHeight();
        // Push height to array.
        imageHeights.push(parseInt(height));
    });    

    if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Modules: Equalising descriptions here is the height for all the descriptions " + imageHeights + " for ", context);
    }
    // Apply the larged height to the description.
    context.find('.description').css('height', Math.max.apply(Math,imageHeights))
}


// Default module cms content height IF no banner is found. 
const cmsModuleDefaultContentHeight = 475;

// If a cms module has an image then add class & equalise the content with banner image.
function cmsModuleImageEqualise(context) {

    // Check whether read more is set. 
    let isReadMore = context.find('.read-more').length > 0;
    // If banner exists check to make sure it is on the same line.
    if (context.find('.content-banner').length) {
        // Get content position.
        let contentPosition = context.find('.content-container').offset().top;
        // Get banner position.
        let bannerPosition = context.find('.content-banner').offset().top;
        // If not on the same row then exit.
        if (contentPosition != bannerPosition) {
            return false;
        }
    }

    if (context.find('.content-banner').length > 0 && !context.hasClass('column')) {
        // Equalise the content with the banner.
        let bannerHeight = parseInt(context.find('.content-banner').height());
        // If we cannot find the height ( sometimes due to initialisation issues ) then fallback to cmsModuleDefaultContentHeight.
        if (bannerHeight == 0) {
            bannerHeight = cmsModuleDefaultContentHeight;
            if (AXISDebug.level() >= 2) {
                AXISDebug.output(2,"Modules: Could not find banner height so using default which is " + bannerHeight);
            }
        }
        
        // Does this module have a heading.
        if (context.find('.content-heading').length > 0) {
            bannerHeight = bannerHeight + context.find('.content-heading').height();
        }
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Modules: Module image height = " + bannerHeight);
        }
        if (isReadMore) {
            context.find('.content-container').css('height', bannerHeight);
        }
    } else if (context.find('.content-banner').length == 0) {
        
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Modules: No banner found defaulting content to = " + cmsModuleDefaultContentHeight + "px");
        }
        // if (!context.hasClass('column-invert') && !context.hasClass('column') && context.find('.read-more').length > 0) {
        // Suppressing as we may not have cmsModuleDefaultContentHeight worth of content which will result in white space.
        // if (isReadMore) {
            //context.find('.content-container').css('height', cmsModuleDefaultContentHeight);
        // }

    }
}

function hasAssociatedBanner(context) {
    if (context.find('.content-banner').length > 0) {
        context.addClass('has-image');
        return true;
    } else {
        return false;
    }
}

function cmsModuleImageIntialiseAll() {
    $(window).on('load', function() { 
        // Check which modules have associated banner(s).
        $('.blog-module, .news-module, .events-module, .entry-module').each(function() {
            let context = $(this);
            hasAssociatedBanner(context);
            cmsModuleImageEqualise(context);
        });
    });
}



$(window).on('load', function() { 
    if ($('.grid-x[data-equalizer=equalize-module]')) {
        $('.grid-x[data-equalizer=equalize-module]').each(function() {
            let context = $(this);
            context.foundation('getHeights', function(cb) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1, "Equaliser: Here are the module module heights: ", cb);
                }
                context.foundation('applyHeight', cb)
            });


            $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){
                context.foundation('getHeights', function(cb) {
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(1, "Equaliser: Here are the module module heights: ", cb);
                    }
                    context.foundation('applyHeight', cb)
                });
            });
        })
    }
});



function initialiseAll() {
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Modules: Attempting to initialise equalisation for all modules / collections");
    }
    $(window).on('load', function() { 
        $(expressSelectors()['modules']['equalise-modules']).each(function() {
            // Grab Context.
            let context = $(this);
            // Run equalisation tasks.
            initialiseModuleEqualise(context);
        });
    });


    // Re-equalise due to viewport change.
    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
        for (let instance in equaliseInstances) {
            // Get foundation's equalizer config.
            let config = getEqualiseElement(instance);
            // Check whether to equalise by row? 
            let equaliseByRow = config['options']['equalizeByRow'];
            // Check if instance is still in DOM as it could have been removed due to AJAX.
            let elementRemoved = !$('body').find(equaliseInstances[instance]['element']['$element']).length;
            // If the equalise element has been removed from the DOM then remove instance.
            if (elementRemoved) {
                // Remove express's instance.
                removeEqualiseInstance(instance);
            } else {
                // Clear out old heights.
                config.$watched.each(function() {
                    $(this).css('height', '');
                });
                config.$element.foundation((equaliseByRow ? "getHeightsByRow" : "getHeights"), (heights) => {
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(1, "Equaliser: Here are the module module " + instance + " heights: ", heights);
                    }
                    config.$element.foundation((equaliseByRow ? "applyHeightByRow" : "applyHeight"), heights);
                });
            }    
        }
    });
}

var equaliseInstances = {};

function setEqualiseInstance(context) {
    let id = context.attr('equalise-id');
    // If this tooltip has not been initialise then create new instance.
    if (!id) {
        id = generateId();
        // Assign id.
        context.attr('equalise-id', id);
        // Create a new instance.
        equaliseInstances[id] = {};
    }
    return id;
}

function getEqualiseInstance(context) {
    return context.attr('equalise-id');
}

function removeEqualiseInstance(id) {
    delete equaliseInstances[id];
    // Check if instance is still within the instance obj.
    if (!equaliseInstances.hasOwnProperty(id)) {
        return true;
    } else {
        AXISDebug.output(3,"Equaliser: Failed to remove instance.");
        return false;
    }

}

function setEqualiseElement(id, value) {
    equaliseInstances[id]['element'] = value;
    return equaliseInstances[id]['element'];
}

function getEqualiseElement(id) {
    return equaliseInstances[id]['element'];
}

function initialiseModuleEqualise(context) {
    Promise.all([initialiseImageEqualise(context), initialiseDescriptionEqualise(context), initialiseSpecificationEqualise(context)]).then((values) => {
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Modules: Previous equalisation tasks have been completed, now running the final task.", values);
        }
        initialiseCellEqualise(context).catch((error) => {
            console.log("Failed to equalise cells for",  context);
            console.error(error);
        });
    }).catch((error) => {
        console.error("A equalisation task has failed.", error);
    });
}

// Add in wrapper and watch attributes for images.
function initialiseImageEqualise(context) {
    return new Promise((resolve, reject) => {
        // Wrap all children in a container.
        context.children().wrapAll("<div data-equalizer='equalise-image'></div>");
        // Create instance id for express.
        let id = setEqualiseInstance(context.find('[data-equalizer=equalise-image]'));
        // Unset any previous heights.
        context.find('.content-container.product > a:first-of-type .image').css('height', 'unset');
        // Find all items to watch.
        context.find('.content-container.product > a:first-of-type .image').attr('data-equalizer-watch', 'equalise-image');
        // Find container.
        let container = context.find("[data-equalizer='equalise-image']");
        if (container.length > 0) {
            equaliseInitialise(container).then((element) => {
                setEqualiseElement(id, element);
                resolve(element);
            }).catch((error) => {
                console.error(error);
            });
        } else {
            reject("Could not find container");
        }
    });
}

function initialiseDescriptionEqualise(context) {
    return new Promise((resolve, reject) => {
        // Wrap all child in a container.
        context.children().wrapAll("<div data-equalizer='equalise-description'></div>");
        // Create instance id for express.
        let id = setEqualiseInstance(context.find('[data-equalizer=equalise-description]'));
        // Find all items to watch.
        context.find('.description').attr('data-equalizer-watch', 'equalise-description');
        // Find container.
        let container = context.find("[data-equalizer='equalise-description']");
        if (container.length > 0) {
            equaliseInitialise(container).then((element) => {
                setEqualiseElement(id, element);
                resolve(element);
            }).catch((error) => {
                console.error(error);
            });
        } else {
            reject("Could not find container");
        }
    });
}

// Add in wrapper and watch attributes for specifications.
function initialiseSpecificationEqualise(context) {
    return new Promise((resolve, reject) => {
        // Find all items to watch.
        let specifications = context.find('.specification');
        // If none are found then exit.
        if (specifications.length == 0) {
            resolve(specifications.length);
            return true;
        }
        // Wrap all child in a container.
        context.children().wrapAll("<div data-equalizer='equalise-specification'></div>");
        // Create instance id for express.
        let id = setEqualiseInstance(context.find('[data-equalizer=equalise-specification]'));
        context.find('.specification').attr('data-equalizer-watch', 'equalise-specification');
        // Find container.
        let container = context.find("[data-equalizer='equalise-specification']");
        if (container.length > 0) {
            equaliseInitialise(container).then((element) => {
                setEqualiseElement(id, element);
                resolve(element);
            }).catch((error) => {
                console.error(error);
            });
        } else {
            reject("Could not find container");
        }
    });
}

function initialiseCellEqualise(context) {
    return new Promise((resolve, reject) => {
        // Wrap all children in container.
        context.children().wrapAll("<div data-equalizer='equalise-cell'></div>");
        // Create instance id for express.
        let id = setEqualiseInstance(context.find('[data-equalizer=equalise-cell]'));
        // Find all items to watch.
        context.find('.collection-item').attr('data-equalizer-watch', 'equalise-cell');
        // Find container.
        let container = context.find("[data-equalizer='equalise-cell']");
        if (container.length > 0) {
            equaliseInitialise(container).then((element) => {
                setEqualiseElement(id, element);
                resolve(element);
            }).catch((error) => {
                console.error(error);
            });
        } else {
            reject("Could not find container");
        }
    });
}

// All equalisation routes come down to this one function which calls into foundation's api.
function equaliseInitialise(context) {
    return new Promise((resolve, reject) => {
        // Initialise foundation equalizer.
        let element = new Foundation.Equalizer(context, {equalizeByRow: true});
        // Return the initialised obj.
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Modules: Equalising configuration", element);
        }
        resolve(element);
    });
}

var AXISModules = $.AXISModules = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialiseEqualisation: (context) => {
        return initialiseModuleEqualise(context);
    },
    equaliseProductDescriptions: (collection) => {
        return initialiseDescriptionEqualise(collection);
    },
    cmsModuleImageIntialiseAll: (modules) => {
        return cmsModuleImageIntialiseAll(modules);
    }
}

export { AXISModules }